import { FC } from 'react'
import { FutureInputProps, FutureInput } from 'components/atoms/inputs/FutureInput/FutureInput'
import styles from 'components/atoms/inputs/FutureSelectInput/FutureSelectInput.styl'


type FutureSelectInputProps = FutureInputProps
export const FutureSelectInput: FC<FutureSelectInputProps> = (props) => {
  return (
    <div className={ styles.futureSelectInput }>
      <FutureInput
        autoComplete='new-password' // Prevents autocompletion better than 'off'
        data-lpignore='true' // Prevent LastPass from treating field
        { ...props }
      />
    </div>
  )
}
